// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMActivityFeed.tsx — PropelMapper activity rail.
//
// The recurring "Recent activity" surface: a PMCard-style feed of events (actor
// avatar + rich line + relative time) with an optional "active people" footer
// (overlapping avatar stack + label). Standardized from the web-app home + the
// dashboards. Presentational + token-driven; light/dark.
//
//   <PMActivityFeed title="Recent activity" headerLink={{label:"View all", onClick}}
//     items={[
//       { id:1, avatar:{initials:"JO", color:"var(--pm-info)"},
//         text:<><b>Jess Okoro</b> completed a field visit — <a>Greenfield Station</a></>,
//         time:"12 min ago" },
//     ]}
//     activePeople={{ avatars:[{initials:"JO",color:"var(--pm-info)"}], label:"4 people active in the last 24 hours" }} />

const PMFEED_CSS = `
.pmfeed{font-family:var(--pm-font-sans)}
.pmfeed-eyebrow{display:flex;align-items:center;gap:8px;margin:0 0 12px;padding:0 2px;font:var(--pm-section);font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--pm-fg-1)}
.pmfeed-eyebrow .pmfeed-ico{display:inline-flex;width:17px;height:17px;color:var(--pm-primary)}
.pmfeed-eyebrow .pmfeed-ico svg{display:block;width:100%;height:100%}
.pmfeed-link{margin-left:auto;display:inline-flex;align-items:center;gap:3px;font-size:12px;font-weight:600;color:var(--pm-primary);text-transform:none;letter-spacing:0;cursor:pointer;background:none;border:none;font-family:inherit}
.pmfeed-link:hover{color:var(--pm-primary-dark)}
.pmfeed-link .pmfeed-ico{width:15px;height:15px;color:currentColor}
.pmfeed-card{background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-card);padding:18px}
.pmfeed-item{display:flex;gap:11px;padding:12px 0;border-top:1px solid var(--pm-border-light)}
.pmfeed-item:first-child{border-top:none}
.pmfeed-av{width:28px;height:28px;border-radius:50%;display:grid;place-items:center;font:var(--pm-label-s);font-weight:700;color:#fff;flex:0 0 28px;overflow:hidden}
.pmfeed-av .pmfeed-ico{width:16px;height:16px;color:#fff}
.pmfeed-av .pmfeed-ico svg{display:block;width:100%;height:100%}
.pmfeed-av img{width:100%;height:100%;object-fit:cover}
.pmfeed-bd{min-width:0}
.pmfeed-tx{font:var(--pm-body-s);color:var(--pm-fg-1);line-height:1.5}
.pmfeed-tx b{font-weight:700}
.pmfeed-tx a{color:var(--pm-primary);font-weight:600;cursor:pointer}
.pmfeed-tx .tgt{color:var(--pm-fg-2)}
.pmfeed-time{font:var(--pm-label-s);color:var(--pm-fg-3);margin-top:3px}
.pmfeed-people{display:flex;align-items:center;gap:10px;margin-top:14px;padding-top:14px;border-top:1px solid var(--pm-border)}
.pmfeed-stack{display:flex}
.pmfeed-stack .pmfeed-av{border:2px solid var(--pm-surface);margin-left:-8px}
.pmfeed-stack .pmfeed-av:first-child{margin-left:0}
.pmfeed-people .lbl{font:var(--pm-body-s);color:var(--pm-fg-2)}
.pmfeed-empty{font:var(--pm-body-s);color:var(--pm-fg-3);padding:8px 2px}
`;

function pmfeedEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmfeed-css")) return;
  const s = document.createElement("style"); s.id = "pmfeed-css"; s.textContent = PMFEED_CSS;
  document.head.appendChild(s);
}

function pmfeedResolve(name: any) {
  if (!name) return null;
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  return I[name] || I[name + "-outline"] || I[name + "-filled"] || null;
}
function PMFeedIco({ name, fallback = "" }: any) {
  const svg = pmfeedResolve(name);
  if (svg) return <span className="pmfeed-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  if (fallback) return <span className="pmfeed-ico" aria-hidden="true" style={{ fontWeight: 700 }}>{fallback}</span>;
  return null;
}

function PMFeedAvatar({ data }: any) {
  if (!data) return null;
  const style: any = { background: data.color || "var(--pm-surface-variant)" };
  if (!data.color && (data.icon || data.image)) style.background = "var(--pm-surface-variant)";
  return (
    <span className="pmfeed-av" style={style} title={data.name || undefined}>
      {data.image ? <img src={data.image} alt="" /> : data.icon ? <PMFeedIco name={data.icon} /> : (data.initials || "")}
    </span>
  );
}

export function PMActivityFeed({
  items = [],
  title,
  icon,
  headerLink = null,
  activePeople = null,
  emptyLabel = "No recent activity.",
  className = "",
  style = {},
}: any) {
  pmfeedEnsureCSS();
  return (
    <div className={"pmfeed" + (className ? " " + className : "")} style={style}>
      {title || headerLink ? (
        <div className="pmfeed-eyebrow">
          {icon ? <PMFeedIco name={icon} /> : null}
          {title ? <span>{title}</span> : <span />}
          {headerLink ? (
            <button type="button" className="pmfeed-link" onClick={headerLink.onClick}>
              {headerLink.label}<PMFeedIco name={headerLink.icon || "chevron-right"} fallback="›" />
            </button>
          ) : null}
        </div>
      ) : null}
      <div className="pmfeed-card">
        {items.length === 0 ? <div className="pmfeed-empty">{emptyLabel}</div> : null}
        {items.map((it: any, i: number) => (
          <div className="pmfeed-item" key={it.id != null ? it.id : i}>
            <PMFeedAvatar data={it.avatar} />
            <div className="pmfeed-bd">
              <div className="pmfeed-tx">{it.text}</div>
              {it.time ? <div className="pmfeed-time">{it.time}</div> : null}
            </div>
          </div>
        ))}
        {activePeople && activePeople.avatars && activePeople.avatars.length ? (
          <div className="pmfeed-people">
            <div className="pmfeed-stack">
              {activePeople.avatars.map((a: any, i: number) => <PMFeedAvatar key={i} data={a} />)}
            </div>
            {activePeople.label ? <span className="lbl">{activePeople.label}</span> : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
